// localization/editor-i18n/dictionary.json
var dictionary_default = {
  Vorschau: "Preview",
  "DEINE GESTALTUNG": "YOUR DESIGN",
  "Live-Vorschau": "Live preview",
  "SureFeed mit wei\xDFer Beschriftungsfl\xE4che": "SureFeed with a white label area",
  "Fotovorschau \xB7 Farben, Glanz und Folieneffekte k\xF6nnen je nach Bildschirm, Bildschirmeinstellungen und Licht vom Original abweichen.": "Photo preview \xB7 Colours, shine and foil effects may differ from the original depending on your screen, display settings and lighting.",
  "Das Foto zeigt nur einen Ausschnitt. Der vollst\xE4ndige Sticker ist in der Ma\xDFansicht darunter zu sehen.": "The photo shows a cropped view. The complete sticker is shown in the dimensions view below.",
  "Ausgew\xE4hlter Sticker": "Selected sticker",
  "Inklusive Symbole": "Including symbols",
  "Deine Sticker im Vergleich": "Compare your stickers",
  "Gleicher Ma\xDFstab": "Same scale",
  "Empfohlen: 2\u20134 cm hoch, maximal 14 cm lang. Die Vorschau dient zur Veranschaulichung.": "Recommended: 2\u20134 cm high and no more than 14 cm long. The preview is for illustration purposes.",
  Produktionsdatei: "Production file",
  "SVG mit Schriftkonturen, in Millimetern. Nach dem Import in Cricut die angezeigten Ma\xDFe kontrollieren.": "SVG with outlined text in millimetres. Check the displayed dimensions after importing into Cricut.",
  "SVG herunterladen": "Download SVG",
  "Alle SVGs als ZIP": "Download all SVGs as ZIP",
  "Gestaltung speichern": "Save design",
  "Gespeicherte Gestaltung laden": "Load saved design",
  "Namensschild gestalten": "Design a name sticker",
  "F\xFCr deinen Liebling. Von dir gestaltet.": "For your pet. Designed by you.",
  "Gestalte deine Aufkleber f\xFCr den SureFeed\xAE.": "Design your stickers for the SureFeed\xAE.",
  "Deine Sticker": "Your stickers",
  "+ Weiteren Sticker": "+ Add another sticker",
  "Schriftgr\xF6\xDFe der Namen angleichen": "Match the name font sizes",
  Name: "Name",
  Schriftart: "Font",
  "Vorl\xE4ufige Standardschrift \u2013 die Originalschrift folgt.": "Temporary default font \u2013 the original font will follow.",
  Folie: "Vinyl",
  Farbe: "Colour",
  Folienfarbe: "Vinyl colour",
  Symbole: "Symbols",
  "Anzahl der Symbole": "Number of symbols",
  "Ohne Symbol": "No symbol",
  Symbol: "Symbol",
  "Symbol w\xE4hlen": "Choose a symbol",
  "Symbolauswahl schlie\xDFen": "Close symbol picker",
  Position: "Position",
  "Links vom Namen": "To the left of the name",
  "Rechts vom Namen": "To the right of the name",
  Gr\u00F6\u00DFe: "Size",
  "Gew\xFCnschte H\xF6he": "Desired height",
  "Maximale L\xE4nge": "Maximum length",
  "Die Proportionen bleiben erhalten. Bei langen Namen wird die H\xF6he passend verkleinert.": "The proportions are preserved. Long names are scaled down to fit the maximum length.",
  "Preis aus den Produktvarianten": "Price from product variants",
  "Inkl. Steuern, Versand im Checkout": "Taxes included; shipping calculated at checkout",
  "Shop-Vorschau": "Shop preview",
  Testmodus: "Test mode",
  "In den Warenkorb": "Add to basket",
  "In dieser Vorschau wird keine Bestellung aufgegeben.": "No order will be placed from this preview.",
  "Normale Folie": "Standard vinyl",
  "Metallic-Folie": "Metallic vinyl",
  "Holografische Folie": "Holographic vinyl",
  Glitzerfolie: "Glitter vinyl",
  Schwarz: "Black",
  Grau: "Grey",
  Wei\u00DF: "White",
  Hellblau: "Light blue",
  Blau: "Blue",
  T\u00FCrkis: "Turquoise",
  Hellgr\u00FCn: "Light green",
  Gr\u00FCn: "Green",
  Gelb: "Yellow",
  Orange: "Orange",
  Rot: "Red",
  Rosa: "Pink",
  Pfirsich: "Peach",
  Lila: "Purple",
  Flieder: "Lilac",
  Magenta: "Magenta",
  Gold: "Gold",
  Silber: "Silver",
  Kupfer: "Copper",
  Ros\u00E9: "Rose gold",
  "Herz gef\xFCllt": "Solid heart",
  "Herz mit Pfotenausschnitt": "Heart with paw cut-out",
  "Herz Kontur": "Heart outline",
  "Herz mit Pfote": "Heart with paw",
  "Herz mit zwei Pfoten": "Heart with two paws",
  "Zwei Herzen": "Two hearts",
  "Herz mit Katzenkopfausschnitt": "Heart with cat-head cut-out",
  "Herz mit Katze": "Heart with cat",
  "Herz mit Hund": "Heart with dog",
  "Herz mit Schlappohrhund": "Heart with floppy-eared dog",
  "Stern gef\xFCllt": "Solid star",
  "Stern Kontur": "Star outline",
  "Stern mit Pfote": "Star with paw",
  Mond: "Moon",
  "Mond mit Katze": "Moon with cat",
  Pfote: "Paw",
  "Zwei Pfoten": "Two paws",
  "Schnurrhaare um Namen": "Whiskers around the name",
  "Krone gef\xFCllt": "Solid crown",
  "Krone Kontur": "Crown outline",
  Prunkkrone: "Ornate crown",
  "Knochen gef\xFCllt": "Solid bone",
  "Knochen Kontur": "Bone outline",
  Fischgr\u00E4te: "Fish skeleton",
  Blitz: "Lightning bolt",
  Katzenkopf: "Cat head",
  "Katzenkopf mit Pfote": "Cat head with paw",
  "Neuer Name": "New name",
  Rechts: "Right",
  Links: "Left",
  "Dein Symbol": "Your symbol",
  \u00C4ndern: "Change",
  "Rechtes Symbol": "Right symbol",
  "Linkes Symbol": "Left symbol",
  "Metallischer Glanz zur Veranschaulichung. Die tats\xE4chliche Wirkung h\xE4ngt vom Licht und Blickwinkel ab.": "Illustrated metallic shine. The actual effect depends on the light and viewing angle.",
  "Glitzereffekt nach unseren Farbmustern gerendert. Die tats\xE4chliche Wirkung h\xE4ngt vom Licht und Blickwinkel ab.": "Glitter effect rendered from our colour samples. The actual effect depends on the light and viewing angle.",
  "Farbmuster aus unseren Produktfotos. Glanz und Farbwechsel h\xE4ngen vom Licht und Blickwinkel ab.": "Colour sample taken from our product photos. Shine and colour shifts depend on the light and viewing angle.",
  "H\u2013K folgen, sobald ihre Farbfotos vorliegen.": "H\u2013K will follow as soon as their colour photos are available.",
  "Angen\xE4herte Vorschau aus der Buchstabenvorlage. Fertigung mit Alyssa Stencil in Cricut; kein Schnittdatei-Export dieser Vorschau.": "Approximate preview based on the letter template. Production uses Alyssa Stencil in Cricut; this preview cannot be exported as a cut file.",
  "Diese Schrift wird angen\xE4hert dargestellt. Die Fertigung erfolgt mit der Originalschrift.": "This font is shown as an approximation. The original font is used for production.",
  "Vorschau wird aktualisiert \u2026": "Updating preview \u2026",
  "Die Gro\xDFbuchstaben werden auf dieselbe H\xF6he abgestimmt \u2013 auch bei verschiedenen Schriften. B\xF6gen und Schw\xFCnge z\xE4hlen weiterhin zu den Gesamtma\xDFen.": "Capital letters are matched to the same height, even across different fonts. Curves and flourishes still count towards the overall dimensions.",
  "Jeder Sticker wird proportional in die gew\xE4hlte Gr\xF6\xDFe eingepasst.": "Each sticker is scaled proportionally to fit the selected size.",
  "Mindestens ein Sticker liegt unter den empfohlenen 2 cm H\xF6he. K\xFCrzere Namen, andere Schriften oder weniger Symbole schaffen mehr Platz.": "At least one sticker is below the recommended height of 2 cm. A shorter name, another font or fewer symbols will create more space.",
  "Eine Kombination ist nicht erh\xE4ltlich.": "One combination is unavailable.",
  "Mindestens eine Variante ist derzeit nicht verf\xFCgbar.": "At least one variant is currently unavailable.",
  "Testmodus: Warenkorb deaktiviert.": "Test mode: basket disabled.",
  "Die Schrift konnte nicht geladen werden.": "The font could not be loaded.",
  "Ein Symbol konnte nicht geladen werden.": "A symbol could not be loaded.",
  "Die gespeicherte Gestaltung konnte nicht geladen werden.": "The saved design could not be loaded.",
  "Die Vorschau konnte nicht erstellt werden.": "The preview could not be created.",
  "Die Konfigurationsdatei ist zu gro\xDF.": "The configuration file is too large.",
  "Die Sticker werden zum Warenkorb hinzugef\xFCgt \u2026": "Adding the stickers to your basket \u2026",
  "Die Sticker konnten nicht hinzugef\xFCgt werden.": "The stickers could not be added.",
  "Der Editor konnte nicht geladen werden. Bitte lade die Seite erneut.": "The editor could not be loaded. Please reload the page.",
  "Die Versalh\xF6he dieser Schrift konnte nicht bestimmt werden.": "The capital-letter height could not be determined for this font.",
  "Diese Schrift enth\xE4lt mindestens eines deiner Zeichen nicht. Bitte w\xE4hle eine andere Schrift.": "This font does not include at least one of your characters. Please choose another font.",
  "Bitte gib einen Namen ein.": "Please enter a name.",
  "Der Name enth\xE4lt keine schneidbaren Zeichen.": "The name does not contain any cuttable characters.",
  "Bitte gib einen Namen mit 1\u201330 Zeichen ein.": "Please enter a name containing 1\u201330 characters.",
  "Ung\xFCltige Schrift.": "Invalid font.",
  "Ung\xFCltige Farbe.": "Invalid colour.",
  "Ung\xFCltige gemeinsame Schriftgr\xF6\xDFe.": "Invalid shared font size.",
  "Bitte w\xE4hle eine verf\xFCgbare Folie und Farbe.": "Please choose an available vinyl and colour.",
  "Ung\xFCltige Folie.": "Invalid vinyl.",
  "Material w\xE4hlen, Farbe darunter.": "Choose the material, then the colour below.",
  Schriftgr\u00F6\u00DFe: "Lettering size",
  "Die Schriftgr\xF6\xDFe bleibt fest. Reicht der Platz nicht, verkleinere bitte die Schrift oder die Symbole.": "Lettering size stays fixed. If there is not enough space, reduce the lettering or symbols.",
  "Die gew\xE4hlte Schriftgr\xF6\xDFe bleibt auch beim \xC4ndern der Symbole erhalten.": "Your chosen lettering size stays fixed when changing symbols.",
  "Der Sticker \xFCberschreitet die maximale L\xE4nge oder 4 cm Gesamth\xF6he. Bitte verkleinere die Schrift oder die Symbole. Die Schrift wird nicht automatisch verkleinert.": "The sticker exceeds the maximum length or 4 cm overall height. Please reduce the lettering or symbols. Lettering is not reduced automatically.",
  Symbolgr\u00F6\u00DFe: "Symbol size",
  Kleiner: "Smaller",
  Gr\u00F6\u00DFer: "Larger",
  Standard: "Default",
  "Im Verh\xE4ltnis zur Schrift. Beide Symbole werden gemeinsam angepasst.": "Relative to the lettering. Both symbols are adjusted together.",
  "Symbolgr\xF6\xDFe: 50\u2013110 %.": "Symbol size: 50\u2013110%.",
  "Alyssa Stencil (Vorschau)": "Alyssa Stencil (preview)",
  "Vorschau neu laden": "Reload preview",
  "Die Vorschau konnte nicht gestartet werden.": "The preview could not be started.",
  "Ung\xFCltiger Entwurf.": "Invalid design.",
  "Der gespeicherte Entwurf konnte nicht geladen werden.": "The saved design could not be loaded.",
  "Entwurfslink kopiert. Damit l\xE4sst sich genau diese Auswahl wieder \xF6ffnen.": "Design link copied. It will reopen this exact selection.",
  "Kopieren nicht m\xF6glich. Du kannst den Entwurfscode unten ausw\xE4hlen.": "Copying is not available. You can select the design code below.",
  "Dein Slowfeeder": "Your slow feeder",
  "DEIN SLOWFEEDER": "YOUR SLOW FEEDER",
  "Dein Tiername": "Your pet\u2019s name",
  "hat seinen Platz.": "has their place.",
  Klassik: "Classic",
  "Drehbare Vorschau deiner personalisierten Klassiksch\xFCssel": "Rotatable preview of your personalised classic bowl",
  "Drehen & zoomen": "Rotate & zoom",
  Perspektive: "Perspective",
  "Von oben": "Top view",
  "Ansicht zur\xFCcksetzen": "Reset view",
  Originalsch\u00FCssel: "Original bowl",
  Sch\u00FCsselh\u00F6he: "Bowl height",
  "Name / Symbole erhaben": "Raised name / symbols",
  "KLASSIK \xB7 PERSONALISIERT": "CLASSIC \xB7 PERSONALISED",
  "Ein Napf.": "One bowl.",
  Ganz: "Made",
  "f\xFCr deinen Liebling.": "for your pet.",
  "Tiernamen eingeben, Lieblingsmotiv w\xE4hlen und deinen Napf von allen Seiten ansehen.": "Enter your pet\u2019s name, choose a favourite motif and view your bowl from every angle.",
  Tiername: "Pet name",
  "z. B. LUNA": "e.g. LUNA",
  "Gill Sans Bold \xB7 Der Name wird passend zentriert und gleichm\xE4\xDFig verkleinert.": "Gill Sans Bold \xB7 The name is centred and scaled down evenly to fit.",
  "Dein Motiv": "Your motif",
  Motiv: "Motif",
  Herz: "Heart",
  Stern: "Star",
  Halbmond: "Crescent moon",
  Knochen: "Bone",
  "Sechs Motivelemente umgeben den Namen.": "Six motif elements surround the name.",
  Farben: "Colours",
  "Deine Farben": "Your colours",
  Mehrfarbig: "Multicolour",
  Einfarbig: "Single colour",
  "Schale, Name und Symbole separat \xB7 24,95 \u20AC": "Separate bowl, name and symbol colours \xB7 \u20AC24.95",
  "Eine Farbe f\xFCr den ganzen Napf \xB7 21,95 \u20AC": "One colour for the entire bowl \xB7 \u20AC21.95",
  Schale: "Bowl",
  "Sch\xFCssel und Unterbau von Name und Symbolen.": "Bowl and the base layers beneath the name and symbols.",
  "Nur der oberste 1 mm des Namens.": "Only the top 1 mm of the name.",
  "Nur der oberste 1 mm der Symbole.": "Only the top 1 mm of the symbols.",
  Napffarbe: "Bowl colour",
  "Eine gemeinsame Farbe f\xFCr Schale, Name und Symbole.": "One colour for the bowl, name and symbols.",
  "Die Bildschirmfarben dienen als Vorschau.": "On-screen colours are a preview.",
  "Dein Entwurf": "Your design",
  "DEIN ENTWURF": "YOUR DESIGN",
  "Ohne Namen": "No name",
  Preis: "Price",
  "Dein Preis": "Your price",
  "Interne Fertigung": "Internal production",
  "Datei wird erstellt \u2026": "Creating file \u2026",
  "3MF herunterladen": "Download 3MF",
  "STL zum Testen herunterladen": "Download STL for testing",
  "Mehrfarbiger Druck: 3MF mit getrennten Farbbereichen. Im Slicer jedem Teil das passende Filament zuordnen.": "Multicolour print: 3MF with separate colour areas. Assign the matching filament to each part in the slicer.",
  "Einfarbiger Druck: Sch\xFCssel, Name und Symbole als ein zusammenh\xE4ngendes STL-Druckmodell.": "Single-colour print: bowl, name and symbols as one connected STL model.",
  "Entwurfslink kopieren": "Copy design link",
  "Entwurf laden & Modelldetails": "Load design & model details",
  "Entwurfscode aus der Bestellung": "Design code from the order",
  "SF1:\u2026 oder SF2:\u2026": "SF1:\u2026 or SF2:\u2026",
  "Entwurf geladen.": "Design loaded.",
  "Ung\xFCltiger Code.": "Invalid code.",
  "Entwurf laden": "Load design",
  "Gill Sans Bold \xB7 Name 18 mm \xB7 Symbole 15 mm \xB7 Kantenradius 1 mm": "Gill Sans Bold \xB7 Name 18 mm \xB7 Symbols 15 mm \xB7 Edge radius 1 mm",
  "Buchstaben-Innenr\xE4ume sind 2 mm tief. Pfoten haben einen 14 mm hohen gemeinsamen Sockel und 1 mm Relief dar\xFCber. Motive sind anhand deiner Bildvorlage neu aufgebaut. Den ersten Druck bitte mit deiner bisherigen Ausf\xFChrung vergleichen.": "Letter counters are 2 mm deep. Paw motifs share a 14 mm-high base with 1 mm relief above it. Motifs have been rebuilt from your image template. Please compare the first print with your previous version.",
  "Die drei Farbbereiche werden f\xFCr den Druck vorbereitet \u2026": "Preparing the three colour areas for printing \u2026",
  "Sch\xFCssel, Name und Motive werden verbunden \u2026": "Connecting bowl, name and motifs \u2026",
  "Originalmodell nicht erreichbar.": "The original model could not be reached.",
  "3MF erstellt. Die Teile Schale, Name und Symbole im Slicer den passenden Filamenten zuordnen.": "3MF created. Assign the matching filament to the bowl, name and symbol parts in the slicer.",
  "STL erstellt: Sch\xFCssel, Name und Symbole sind zu einem Druckk\xF6rper verbunden.": "STL created: bowl, name and symbols are connected as one printable body.",
  "Export fehlgeschlagen.": "Export failed.",
  "Unbekannte Modellversion.": "Unknown model version.",
  "Bitte h\xF6chstens 16 Buchstaben, Zahlen, Leerzeichen oder Bindestriche eingeben.": "Please enter no more than 16 letters, numbers, spaces or hyphens.",
  "Ung\xFCltiger Farbmodus.": "Invalid colour mode.",
  "Ung\xFCltige Auswahl.": "Invalid selection.",
  "Der Name darf in Gro\xDFbuchstaben h\xF6chstens 16 Zeichen haben.": "The name may contain no more than 16 characters when converted to capitals.",
  "Dein Entwurf ist bereit.": "Your design is ready.",
  "Dein Entwurf ist bereit. Dieser Testartikel ist noch nicht zum Kauf freigegeben.": "Your design is ready. This test item is not yet available to buy.",
  "Gestaltung bearbeiten": "Edit design",
  "Dein Entwurf wird mit dem Warenkorbartikel gespeichert.": "Your design will be saved with the basket item.",
  "Diese Ausf\xFChrung ist derzeit nicht bestellbar.": "This style is currently unavailable.",
  "SAUM gestalten": "Design your SAUM",
  "Dein Name.": "Your name.",
  "Deine Farben.": "Your colours.",
  "DEIN GESAMTPREIS": "YOUR TOTAL PRICE",
  "Inkl. MwSt. \xB7 zzgl. Versand": "VAT included \xB7 shipping extra",
  "Inkl. MwSt. \xB7 zzgl. Versandkosten": "VAT included \xB7 shipping extra",
  "Drehbare 3D-Vorschau des SAUM Napfhalters": "Rotatable 3D preview of your SAUM bowl holder",
  Vorne: "Front",
  "Von unten": "Bottom view",
  "Napfeinsatz zeigen": "Show bowl insert",
  "Ziehen zum Drehen \xB7 Scrollen zum Zoomen": "Drag to rotate \xB7 scroll to zoom",
  "EIN KLARER FARBAKZENT": "A DISTINCTIVE TOUCH OF COLOUR",
  "Weich gerundete Kanten, ein eingelassener Napfrand und dein Name direkt auf dem Halter.": "Softly rounded edges, a recessed bowl rim and your name directly on the holder.",
  "Der Name": "Your name",
  "H\xF6he des Namens \xB7 Z": "Name position \xB7 Z",
  "Position zur\xFCcksetzen": "Reset position",
  "Tipps zu Name und Schrift": "Name and lettering tips",
  "Erhabene Schrift in der Akzentfarbe. Lange Namen werden automatisch eingepasst.": "Raised lettering in your accent colour. Long names are resized to fit.",
  "Die Namensposition gibt die Schriftunterkante an, vom Boden aus gemessen. \u201EPosition zur\xFCcksetzen\u201C platziert den Namen automatisch.": "The name position is the lower edge of the lettering, measured from the base. Choose \u2018Reset position\u2019 to place the name automatically.",
  "PLA-Farben": "PLA colours",
  "Deine bisherigen Farben wurden auf die PLA-Palette angepasst.": "Your previous colours have been adjusted to the PLA palette.",
  K\u00F6rper: "Body",
  "Saum & Name": "Trim & name",
  "K\xF6rper- und Akzentfarbe tauschen": "Swap body and accent colours",
  "\u21C4 Farben tauschen": "\u21C4 Swap colours",
  "Hinweise zu den Farben": "About the colours",
  "14 Farben f\xFCr deinen Halter. K\xF6rper und Akzent frei kombinieren.": "14 colours for your holder. Mix and match the body and accent colours.",
  "Die Bildschirmvorschau kann vom gedruckten PLA abweichen.": "The on-screen preview may differ from the printed PLA.",
  Proportionen: "Proportions",
  H\u00F6he: "Height",
  "Saumh\xF6he unten": "Lower trim height",
  Saumlinie: "Trim shape",
  "Schwung nach oben": "Upward curve",
  "H\xF6he und Saum erkl\xE4rt": "About height and trim",
  "Ab 15,90 \u20AC bei 40 mm. Je +1 \u20AC ab 50, 60, 70 mm usw. Deine gew\xE4hlte H\xF6he bleibt erhalten.": "From \u20AC15.90 at 40 mm. Add \u20AC1 at 50, 60, 70 mm and so on. Your chosen height is preserved.",
  "Die Saumlinie steigt \xFCber die eingestellte Saumh\xF6he hinaus.": "The trim shape rises above the selected lower trim height.",
  Oberfl\u00E4che: "Surface",
  Muster: "Pattern",
  Mustertiefe: "Pattern depth",
  Musterabstand: "Pattern spacing",
  "Hinweise zum Muster": "About the pattern",
  "Echtes Relief im Druckmodell. Der Bereich um den Namen bleibt glatt.": "Real relief in the printed model. The area around the name stays smooth.",
  "Deine Auswahl": "Your selection",
  Edelstahln\u00E4pfe: "Stainless steel bowls",
  Edelstahlnapf: "Stainless steel bowl",
  "Ohne Edelstahlnapf": "Without a stainless steel bowl",
  "Napfpreise im Detail": "Bowl pricing explained",
  "Erster Napf +6 \u20AC, jeder weitere +5 \u20AC. Ab 4 N\xE4pfen zus\xE4tzlich 1 \u20AC Mengenrabatt. Jeder Edelstahlnapf fasst 160 ml.": "First bowl +\u20AC6; each additional bowl +\u20AC5. Save a further \u20AC1 when choosing 4 or more bowls. Each stainless steel bowl holds 160 ml.",
  Halter: "Holder",
  Gesamtpreis: "Total price",
  "Name, Schrift, Farben, Saumform und Muster sind im Halterpreis enthalten.": "Name, font, colours, trim shape and pattern are included in the holder price.",
  "Ich best\xE4tige, dass meine Auswahl verbindlich ist und der Halter nach den angezeigten Gestaltungsangaben gefertigt wird.": "I confirm that my selection is final and the holder will be made to the design specifications shown.",
  "In den Warenkorb einf\xFCgen": "Add to basket",
  "3D-Modell wird vorbereitet \u2026": "Preparing 3D model \u2026",
  "Aktueller Gesamtpreis": "Current total price",
  Klar: "Clear",
  Rund: "Round",
  Verspielt: "Playful",
  Gerade: "Straight",
  Welle: "Wave",
  B\u00F6gen: "Scallops",
  Glatt: "Smooth",
  Rillen: "Grooves",
  Ringe: "Rings",
  Wellen: "Waves",
  Gedreht: "Twist",
  Rauten: "Diamonds",
  Punkte: "Dots",
  "Ohne Namensschrift": "Without name lettering",
  "Entwurf wird aktualisiert \u2026": "Updating design \u2026",
  "Die 3D-Vorschau ben\xF6tigt WebGL. Bitte einen anderen Browser verwenden.": "The 3D preview requires WebGL. Please use another browser.",
  "Bitte EUR als W\xE4hrung w\xE4hlen.": "Please select EUR as the currency.",
  "Diese Auswahl ist derzeit nicht bestellbar.": "This selection is currently unavailable.",
  "Wird hinzugef\xFCgt \u2026": "Adding \u2026",
  "Der Warenkorb konnte nicht aktualisiert werden.": "The basket could not be updated.",
  "Der Warenkorbeintrag konnte nicht best\xE4tigt werden. Bitte den Warenkorb pr\xFCfen.": "The basket item could not be confirmed. Please check your basket.",
  "Die Preisvariante ist nicht verf\xFCgbar.": "The price variant is unavailable.",
  "Der Shopify-Preis weicht ab. Bitte die Seite neu laden.": "The Shopify price has changed. Please reload the page.",
  "Die Halterh\xF6he muss zwischen 40 und 100 mm liegen.": "The holder height must be between 40 and 100 mm.",
  "Bitte 0 bis 5 Edelstahln\xE4pfe w\xE4hlen.": "Please choose between 0 and 5 stainless steel bowls.",
  "Bitte eine der 14 PLA-Farben w\xE4hlen.": "Please choose one of the 14 PLA colours.",
  "Ung\xFCltige Namensh\xF6he": "Invalid name position",
  "Au\xDFerhalb der Randaussparung m\xFCssen mindestens 0,6 mm Material verbleiben.": "At least 0.6 mm of material must remain outside the rim recess.",
  "Schrift konnte nicht geladen werden.": "The font could not be loaded.",
  "Modell konnte nicht geschlossen erzeugt werden.": "A closed model could not be generated.",
  "Modellmodul fehlt": "The model module is missing",
  "Editor \xF6ffnen": "Open editor",
  "Editor schlie\xDFen": "Close editor",
  "Schlie\xDFen \xD7": "Close \xD7",
  "3D-Editor wird geladen \u2026": "Loading 3D editor \u2026",
  "Der Editor konnte nicht geladen werden. Bitte lade die Seite neu.": "The editor could not be loaded. Please reload the page.",
  "Deine Namensaufkleber gestalten": "Design your name decals",
  "Dein Editor wird geladen \u2026": "Loading your editor \u2026",
  "Der Editor konnte nicht geladen werden. Bitte schlie\xDFe dieses Fenster und \xF6ffne es erneut.": "The editor could not be loaded. Please close this window and open it again.",
  "Gestalte deinen Namensaufkleber mit deiner Lieblingsschrift, Folie und passenden Symbolen. Auch mehrere Namen kannst du zusammen abstimmen.": "Design your name decal with your favourite font, vinyl and matching symbols. You can coordinate several names together.",
  "Namensaufkleber gestalten": "Design your name decal",
  "Deine Auswahl und den Gesamtpreis siehst du im Editor.": "View your selection and total price in the editor.",
  "Bitte aktiviere JavaScript, um deinen Namensaufkleber zu gestalten.": "Please enable JavaScript to design your name decal.",
  "W\xE4hle Namen, Farben, H\xF6he und N\xE4pfe im Editor. Dort siehst du deinen Gesamtpreis.": "Choose your name, colours, height and bowls in the editor, where you can see your total price.",
  "Bitte aktiviere JavaScript, um deinen Napfhalter zu gestalten.": "Please enable JavaScript to design your bowl holder.",
  "Dieser Entwurfscode ist ung\xFCltig.": "This design code is invalid.",
  "Deine Sch\xFCssel wird geladen \u2026": "Loading your bowl \u2026",
  "Die Originalsch\xFCssel konnte nicht geladen werden.": "The original bowl could not be loaded.",
  "Die Vorschau wird wiederhergestellt \u2026": "Restoring preview \u2026",
  "Die Vorschau konnte nicht berechnet werden. Bitte neu laden.": "The preview could not be generated. Please reload the page.",
  f\u00FCr: "for",
  K\u00F6rperfarbe: "Body colour",
  Akzentfarbe: "Accent colour",
  Schalenfarbe: "Bowl colour",
  Namensfarbe: "Name colour",
  Symbolfarbe: "Symbol colour",
  Ma\u00DFe: "Dimensions",
  Namensposition: "Name position",
  Schrift: "Font",
  Saum: "Trim",
  Automatisch: "Automatic",
  Designbest\u00E4tigung: "Design confirmation",
  "Verbindliche Auswahl best\xE4tigt": "Final selection confirmed",
  Personalisierung: "Personalisation",
  Ausf\u00FChrung: "Style",
  Bearbeiten: "Edit",
  "Gestaltung \xFCbernehmen": "Apply design",
  Schlie\u00DFen: "Close",
  "Entwurf \xFCbernehmen": "Apply design",
  "Bitte gestalte zuerst deinen Napf.": "Please design your bowl first.",
  Pflegehinweise: "Care instructions",
  Herstellerinformationen: "Manufacturer information",
  "Hersteller des SAUM Napfhalters": "Manufacturer of the SAUM bowl holder",
  "HUNTER \u2013 Hersteller der Edelstahln\xE4pfe, sofern mitbestellt": "HUNTER \u2013 manufacturer of the stainless steel bowls, if ordered",
  Deutschland: "Germany",
  "vertreten durch die Gesch\xE4ftsf\xFChrer Nadine Trautwein, Jan O\xDFenbrink": "represented by managing directors Nadine Trautwein and Jan O\xDFenbrink",
  "Nicht in die Sp\xFClmaschine": "Do not put in the dishwasher",
  "Am besten kurz einweichen und mit einer weichen B\xFCrste abwaschen": "For best results, soak briefly and wash with a soft brush",
  "Schriftgr\xF6\xDFe: 0,5\u20134 cm; Symbolgr\xF6\xDFe: 50\u2013100 %.": "Lettering size: 0.5\u20134 cm; symbol size: 50\u2013100%.",
  "Modell & Farbteile \xB7 3MF": "Model & colour parts \xB7 3MF",
  "Fertigung und Export": "Production and export",
  "160-ml-Napf \xB7 best\xE4tigte Passform": "160 ml bowl \xB7 confirmed fit",
  "Die Ma\xDFe sind f\xFCr deinen passenden 160-ml-Napf fest eingestellt.": "Dimensions are fixed for the matching 160 ml bowl.",
  "Durchgang unterhalb der Napfauflage in mm": "Opening below the bowl seat in mm",
  "Napfauflage \xD8111,5 mm \xB7 1,4 mm tief \xB7 K\xF6rper \xD8114 mm \xB7 Wand 6,5 mm. Unterseite: f\xFCnf Aufnahmen f\xFCr Gummif\xFC\xDFe, \xD813 mm und 2 mm tief. Der sichtbare Metallnapf ist schematisch.": "Bowl seat \xD8111.5 mm \xB7 1.4 mm deep \xB7 body \xD8114 mm \xB7 wall 6.5 mm. Underside: five recesses for rubber feet, \xD813 mm and 2 mm deep. The metal bowl shown is illustrative.",
  "Einfarbig \xB7 STL": "Single colour \xB7 STL",
  "Passprobe \xB7 STL": "Fit sample \xB7 STL",
  "Die 3MF \xFCbernimmt K\xF6rper-, Saum- und Schriftfarben. In Bambu den Farbimport best\xE4tigen und die passenden Filamente zuordnen.": "The 3MF includes the body, trim and lettering colours. Confirm colour import in Bambu and assign the matching filaments.",
  "160 ml: Passung an der v6-Passprobe best\xE4tigt. Der vollst\xE4ndige Halter ist noch zu pr\xFCfen.": "160 ml: fit confirmed with the v6 fit sample. The complete holder still needs to be checked.",
  "Individuelle Ma\xDFe: Diese Passung ist noch am echten Einsatz zu pr\xFCfen.": "Custom dimensions: this fit still needs checking with the actual insert.",
  Hersteller: "Manufacturer",
  "Gestalte deinen Napf mit Tiernamen, Motiv und deinen Lieblingsfarben.": "Design your bowl with your pet\u2019s name, a motif and your favourite colours.",
  "Napf gestalten": "Design your bowl",
  "Deinen Napf gestalten": "Design your bowl",
  "Bitte zuerst deinen Napf gestalten.": "Please design your bowl first.",
  "Bitte gib einen Tiernamen ein.": "Please enter your pet\u2019s name.",
  "Bitte gestalte deinen Napf im Editor.": "Please design your bowl in the editor.",
  "Bitte gestalte deinen Napf und gib einen Tiernamen ein.": "Please design your bowl and enter your pet\u2019s name."
};

// localization/editor-i18n/runtime.js
var english = (doc = document) => {
  const query = new URL(doc.location.href).searchParams.get("locale");
  return String(query || doc.documentElement.lang || "de").toLowerCase().startsWith("en");
};
function translate(value) {
  if (dictionary_default[value]) return dictionary_default[value];
  let m;
  if (m = value.match(/^(.+) · (.+)$/)) return value.split(" \xB7 ").map(translate).join(" \xB7 ");
  if (m = value.match(/^(Körper|Saum & Name|Schale|Name|Symbole|Schrift|Motiv): (.+)$/)) return `${translate(m[1])}: ${translate(m[2])}`;
  if (m = value.match(/^(.+) – Farbe$/)) return `${translate(m[1])} \u2013 colour`;
  if (m = value.match(/^(\d+) (Edelstahlnapf|Edelstahlnäpfe)(.*)$/)) return `${m[1]} stainless steel ${m[1] === "1" ? "bowl" : "bowls"}${translate(m[3])}`;
  if (m = value.match(/^\(\+([\d.,]+)\s*€\)$/)) return `(+${euro(m[1])})`;
  if (m = value.match(/^([\d.,]+)\s*€$/)) return euro(m[1]);
  if (m = value.match(/^([\d.,]+)\s*€ für den Halter$/)) return `${euro(m[1])} for the holder`;
  if (m = value.match(/^(€[\d,.]+) für den Halter$/)) return `${m[1]} for the holder`;
  if (m = value.match(/^Preisstufe (.+)$/)) return `Height tier ${m[1]}`;
  if (m = value.match(/^Halter · (.+)$/)) return `Holder \xB7 ${m[1]}`;
  if (m = value.match(/^1 gestalteter Halter in (\d+) mm Höhe(.*)$/)) return `1 personalised holder, ${m[1]} mm high${translate(m[2])}`;
  if (m = value.match(/^\s*\+ (\d+) (Edelstahlnapf|Edelstahlnäpfe) à 160 ml$/)) return ` + ${m[1]} stainless steel ${m[1] === "1" ? "bowl" : "bowls"}, 160 ml each`;
  if (value === "ohne Edelstahlnapf") return "without a stainless steel bowl";
  if (m = value.match(/^(\d+) (Napf|Näpfe)$/)) return `${m[1]} ${m[1] === "1" ? "bowl" : "bowls"}`;
  if (value === "ohne Napf") return "without a bowl";
  if (m = value.match(/^Schrift ([\d,]+) mm hoch( \(automatisch eingepasst\))?$/)) return `Lettering ${m[1].replace(",", ".")} mm high${m[2] ? " (resized to fit)" : ""}`;
  if (value === "0,6 mm Relief") return "0.6 mm relief";
  if (m = value.match(/^Der Name wurde auf ([\d,]+) mm Schrifthöhe eingepasst\.$/)) return `The name has been resized to a lettering height of ${m[1].replace(",", ".")} mm.`;
  if (m = value.match(/^Bitte höchstens (\d+) Buchstaben, Zahlen oder Bindestriche verwenden\.$/)) return `Please use no more than ${m[1]} letters, numbers or hyphens.`;
  if (m = value.match(/^Ungültiges Maß: (.+)$/)) return `Invalid dimension: ${m[1]}`;
  if (m = value.match(/^Ungültige Auswahl: (.+)$/)) return `Invalid selection: ${m[1]}`;
  if (m = value.match(/^Schrift konnte nicht geladen werden: (.+)$/)) return `The font could not be loaded: ${m[1]}`;
  if (m = value.match(/^Modell konnte nicht geladen werden\. Bitte neu laden\. (.*)$/)) return `The model could not be loaded. Please reload the page. ${translate(m[1])}`;
  if (m = value.match(/^für (.+)\.$/)) return `for ${m[1]}.`;
  if (m = value.match(/^(\d+)\. (.+)$/)) return `${m[1]}. ${translate(m[2])}`;
  if (m = value.match(/^([\d,]+) mm$/)) return `${m[1].replace(",", ".")} mm`;
  if (m = value.match(/^(Schwung|Tiefe|Abstand) ([\d.,]+) mm$/)) return `${{ Schwung: "Curve", Tiefe: "Depth", Abstand: "Spacing" }[m[1]]} ${m[2].replace(",", ".")} mm`;
  return value;
}
function euro(value) {
  const amount = Number(value.replaceAll(".", "").replace(",", "."));
  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "EUR" }).format(amount);
}
var skip = "script,style,textarea,input,svg,canvas,[data-products],[data-saum-config],[data-slofe-variants]";
function localize(node) {
  if (node.nodeType === 3) {
    if (node.parentElement?.closest(skip)) return;
    const original = node.nodeValue || "", trimmed = original.trim();
    if (!trimmed) return;
    const next = translate(trimmed);
    if (next !== trimmed) node.nodeValue = original.replace(trimmed, next);
    return;
  }
  if (node.nodeType !== 1 && node.nodeType !== 11) return;
  if (node.nodeType === 1) {
    for (const attr of ["aria-label", "title", "placeholder", "alt"]) {
      if (!node.hasAttribute(attr)) continue;
      const old = node.getAttribute(attr), next = translate(old);
      if (next !== old) node.setAttribute(attr, next);
    }
    if (node.matches(skip)) return;
  }
  for (const child of node.childNodes) localize(child);
}
function start(doc = document) {
  if (!english(doc)) return;
  const watched = /* @__PURE__ */ new WeakSet();
  const watch = (root) => {
    if (!root || watched.has(root)) return;
    watched.add(root);
    localize(root);
    new doc.defaultView.MutationObserver((records) => {
      for (const record of records) {
        if (record.type === "characterData" || record.type === "attributes") localize(record.target);
        for (const node of record.addedNodes) localize(node);
      }
    }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["aria-label", "title", "placeholder", "alt"] });
  };
  const scan = () => {
    for (const host of doc.querySelectorAll('[data-slofe-name],[data-slofe-slowfeed],[data-slofe-editor],[data-saum-root],[data-saum-section],.slofe-name-configure,.saum-configure,[data-slofe-product],[id^="saum-product-details-"],[id^="ProductInfo-"]')) {
      watch(host);
      watch(host.shadowRoot);
      watch(host.closest("dialog"));
    }
    for (const row of doc.querySelectorAll(".cart-item .product-option")) {
      const dt = row.querySelector("dt"), dd = row.querySelector("dd");
      if (!dt || !dd) continue;
      const key = dt.textContent.trim().replace(/:$/, ""), next = translate(key);
      if (next !== key) dt.textContent = next + ":";
      if (!["Name", "Tiername", "Pet name", "Design-ID"].includes(key)) localize(dd);
    }
  };
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => {
      queued = false;
      scan();
    });
  };
  scan();
  new doc.defaultView.MutationObserver(schedule).observe(doc.documentElement, { subtree: true, childList: true });
  doc.addEventListener("click", schedule, true);
  doc.addEventListener("shopify:section:load", schedule);
}
if (typeof document !== "undefined") {
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => start(), { once: true });
  else start();
}
export {
  english,
  localize,
  start,
  translate
};
